import React,{useState,useRef,useEffect} from 'react'
import { Formik, Field } from 'formik'
import axios from 'axios'
import moment from 'moment'
import useOnclickOutside from "react-cool-onclickoutside"
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'
import parse from 'html-react-parser'

import { Form, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import { WindowReload, WindowURL, WindowLocation, RouteURL } from '../../services/redirect'
import Spinner from '../../services/spinner'



export default function ProcessingNotesWindow(props){

  /*----------------------------------------
    HANDLE CLICK OUTSIDE ELEMENT
  -----------------------------------------*/

  const handleClickAway = useOnclickOutside(() => CallbackModal({close:true}));
  function CallbackModal(data){
    if(spinner){
      return false;
    }
    props.callback(data);
  }


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(false);


  return (
    <React.Fragment>

   
            <div className="modalpanel-wrapper">
              <div className="modalpanel-container small right animate__animated animate__slideInRight animate__faster" ref={handleClickAway}>


                {/*---------------------------------------------------------
                 HEADER
                --------------------------------------------------------*/}
                 <div className="modalpanel-header">
                    <div><h2>Processing Note</h2></div>
                    <div onClick={()=>CallbackModal({close:true})}><i className="uil-multiply"></i></div>
                 </div>


                 {/*---------------------------------------------------------
                    BODY
                   --------------------------------------------------------*/}

                 <div className="modalpanel-body">
                    <div className="modalpanel-content">

                    
                    {props.data.map(function(row, key){
                      return<React.Fragment key={key}>
                        <Table definition color='teal'>
                            <Table.Body>

                              <Table.Row>
                                <Table.Cell width={6}>Account Number</Table.Cell>
                                <Table.Cell width={10}>{row.account_number}</Table.Cell>
                              </Table.Row>

                              <Table.Row>
                                <Table.Cell>Account Name</Table.Cell>
                                <Table.Cell>{row.account_name}</Table.Cell>
                              </Table.Row>

                              <Table.Row>
                                <Table.Cell>Product Code</Table.Cell>
                                <Table.Cell>{row.product_code}</Table.Cell>
                              </Table.Row>

                              <Table.Row>
                                <Table.Cell>Product</Table.Cell>
                                <Table.Cell>{row.product_name}</Table.Cell>
                              </Table.Row>

                              <Table.Row>
                                <Table.Cell>Quantity</Table.Cell>
                                <Table.Cell>{row.quantity}</Table.Cell>
                              </Table.Row>

                              <Table.Row>
                                <Table.Cell>Price</Table.Cell>
                                <Table.Cell>{row.price}</Table.Cell>
                              </Table.Row>

                              <Table.Row>
                                <Table.Cell>Carriage</Table.Cell>
                                <Table.Cell>{row.carriage}</Table.Cell>
                              </Table.Row>

                              <Table.Row>
                                <Table.Cell>Handling Fee</Table.Cell>
                                <Table.Cell>{row.handling_fee}</Table.Cell>
                              </Table.Row>

                              <Table.Row>
                                <Table.Cell>Note</Table.Cell>
                                <Table.Cell>{row.note}</Table.Cell>
                              </Table.Row>

                          </Table.Body>
                        </Table>
                      </React.Fragment>
                     })}



                    </div>
                 </div>


                 {/*---------------------------------------------------------
                    FOOTER
                   --------------------------------------------------------*/}

                 <div className="modalpanel-footer right">
                    {/*<Button className="RedButton uppercase strong" size='small' content='Close Window' icon='sign-out' labelPosition='right' 
                    onClick={()=>CallbackModal({close:true})}/>*/}
                 </div>



              </div>{/*.modalpanel-container*/}
            </div>
          
    </React.Fragment>
  )
}
